import css from "./index.module.css";
import Header from "../Header";
import Loading from "../Loading";
import Button from "../Button";
import Team from "./Team";
import Prerequisites from "./Prerequisites";
import backgroundImage from "../../assets/emptyImage.png"
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getData, getDataById, insertData, updateData } from "../../utils/fetch";
import { vowelMutation } from "../../utils/text";

/**
 * generic page to display mission or challenge informations with an emabedded link to the worksheet
 * @param {String} taskType Mission || Challenge
 * @param {String} taskId 64 character uuid of given task (mission or challenge)
 * @param {String} studentId 64 character uuid of given student  
 */
const TaskScreen = ({taskType, taskId, studentId }) => {
  const [task, setTask] = useState(null);
  const [taskList, setTaskList] = useState(null);
  const [studentToTask, setStudentToTask] = useState(null);
  const [taskPrerequisites, setTaskPrerequisites] = useState(null);
  const [completedPrerequisites, setCompletedPrerequisites] = useState(null);
  const [student, setStudent] = useState(null);
  const [studentsInClass, setStudentsInClass] = useState(null);
  const [selectedTeamMember, setSelectedTeamMember] = useState(null);

  const navigate = useNavigate();

  /**
   * handle button click to start a mission or challenge. Insert into db current timestamp with other data and reload page
   */
  const startTask = () => {
    const date = new Date();
    if (taskType === "Mission") {
      insertData("/api/studentToMission", {missionId: taskId, studentId: studentId, duration: date.getTime()}).then(() => {
        navigate(0)
      });
    } else if (taskType === "Challenge") {
      insertData("/api/studentToChallenge", {challengeId: taskId, studentId: studentId, student2Id: selectedTeamMember, duration: date.getTime()}).then(() => {
        navigate(0)
      });
    }
  }

  /**
   * handle button click to end a mission or challenge. Update db with total time elapsed since start and reload page
  */
  const endTask = () => {
    const date = new Date();
    if (taskType === "Mission") {
      updateData("/api/studentToMission", {missionId: taskId, studentId: studentId, duration: date.getTime() - studentToTask.duration, completed: true}).then(() => {
        navigate(0)
      });
    } else if (taskType === "Challenge") {
      updateData("/api/studentToChallenge", {challengeId: taskId, studentId: studentId, student2Id: selectedTeamMember, duration: date.getTime() - studentToTask.duration, completed: true}).then(() => {
        navigate(0)
      });
    }
  }

  /**
   * determines if the button on the page starts or ends the task or if it is disabled
   * @returns 
   */
  const handleButton = () => {
    if (taskType === "Mission") {
      if (studentToTask !== null && studentToTask?.completed === true) {
        return <Button disabled>Abgegeben</Button>
      } else if (studentToTask !== null && studentToTask?.completed === null) {
        return <Button onClick={() => endTask()}>Abgeben</Button>
      } else if (studentToTask === null ||studentToTask === undefined) {
        return <Button onClick={() => startTask()}>Starten</Button>
      } else if (studentToTask === null) {
        return <Button disabled>Starten</Button>
      }
    }

      if (studentToTask !== null && studentToTask?.completed === true) {
        return <Button disabled>Abgegeben</Button>
      } else if (studentToTask !== null && studentToTask?.completed === null) {
        return <Button onClick={() => endTask()}>Abgeben</Button>
      } else if (studentToTask === null && (selectedTeamMember === null || selectedTeamMember === undefined)) {
        return <Button disabled>Starten</Button>
      } else if (studentToTask === null && (selectedTeamMember !== null || selectedTeamMember !== undefined)) {
        const required = taskPrerequisites?.filter(e => e.challenge_id === taskId).length;
        const completed = completedPrerequisites?.filter(e => e.challenge_id === taskId && e.student_id === studentId).length;
        if(completed < required) {
          return <Button disabled>Starten</Button>
        } else {
          return <Button onClick={() => startTask()}>Starten</Button>
        }
      }
  }



  useEffect(() => {
    if (taskType === "Mission") {
      getDataById("/api/missions", { missionId: taskId }).then(data => setTask(data[0]));
      getDataById("/api/studentToMission/byId", { missionId: taskId, studentId: studentId}).then(data => setStudentToTask(data[0]));
      getData("/api/missions").then(data => setTaskList(data));
    } else if (taskType === "Challenge") {
      getDataById("/api/challenges", { challengeId: taskId }).then((data) => setTask(data[0]));
      getDataById("/api/studentToChallenge/byId", { challengeId: taskId, studentId: studentId}).then(data => {
        if( data[0] ){
          setStudentToTask(data[0]);
          setSelectedTeamMember(data[0]?.student2_id);
        }
      });
      getData("/api/challengeToMissions").then(data => setTaskPrerequisites(data));
      getData("/api/join/innerjoinCtMwithStM").then(data => setCompletedPrerequisites(data));
      getData("/api/missions").then(data => setTaskList(data));
      getDataById("/api/students/byId", {id: studentId}).then(data => {
        setStudent(data);
        getDataById("/api/students/byClass", {classId: data.class_id}).then(data2 => setStudentsInClass(data2))
      })
    }

    
  }, [taskId, studentId, taskType]);

  const checkDataLoading = (data) => {
    let counter = 0;
    data?.forEach(element => {
      if (element === null) {
        counter++;
      }
    });
    if(counter > 0) {
      return <Loading />
    }
  }

  const checkDataLength = (data) => {
    let counter = 0;
    data?.forEach(element => {
      if (element !== null && data.length === 0) {
        counter++;
      }
    });
    if(counter > 0) {
      return <span>Notwendige Daten nicht verfügbar</span>;
    }
  }

  const checkDataAvailablilty = (data) => {
    let counter = 0;
    data?.forEach(element => {
      if (element !== null && data.length > 0) {
        counter++;
      }
    });
    if(counter > 0) {
      return true;
    }
  }

  if (task == null) {
    return <Loading />;
  } else if (task != null && task.length === 0) {
    return <span>No {taskType} found</span>;
  } else if (task != null) {
    return (
      <div className={css.page}>
        <Header nav={taskType} isTeacher={false} />
        <div className={css.container}>
          <div className={css.info}>
            <div className={taskType === "Challenge" ? css.shortInfoHeader : css.infoHeader}>
              <div className={css.image}>
                <span className={css.name}>{taskType === "Mission" ? taskType + " " : taskType}{task.number}: {task.name}</span>
                <img src={backgroundImage} alt="Hintergrundbild" />
              </div>
              <div className={css.description}>
                {vowelMutation(task.description)} 
              </div>
            </div>
            <div className={css.infoBody}>
              {taskType === "Challenge" && checkDataLoading([taskPrerequisites, completedPrerequisites, taskList])}
              {checkDataLength([taskPrerequisites, completedPrerequisites, taskList])}
              {(checkDataAvailablilty([taskPrerequisites, completedPrerequisites, taskList]) && taskType === "Challenge") &&  
                <Prerequisites challenge={task} challengePrerequisites={taskPrerequisites} completedPrerequisites={completedPrerequisites} missions={taskList}/>
              }
              {taskType === "Challenge" && 
                <Team 
                  studentId={studentId} 
                  student={student} 
                  studentsInClass={studentsInClass} 
                  completedPrerequisites={completedPrerequisites} 
                  challenge={task} 
                  challengePrerequisites={taskPrerequisites}
                  selectedTeamMember={selectedTeamMember}
                  setSelectedTeamMember={setSelectedTeamMember}
                />}
              {handleButton()}
            </div>
          </div>
          {window.innerWidth < 1600 && 
            <ArrowDownwardIcon 
              style={{fontSize: "50px"}}
              onClick={() => {
                const content = document.getElementById("content");
                content.scrollIntoView();
              }}
            />}
          <div className={css.content} id="content">
            {studentToTask != null && studentToTask?.duration != null ?
            <iframe
              title={taskType + "-" + taskId}
              src={"https://drive.google.com/file/d/" + task.link_id + "/preview?usp=sharing" }
            ></iframe>:
            <span>{taskType} noch nicht gestartet</span>}
          </div>
        </div>
      </div>
    );
  }
};

export default TaskScreen;
